import React from 'react';
import sortIcon from '../../assets/icons/sort.png';
import sortAsc from '../../assets/icons/sort_asc.png';
import sortDesc from '../../assets/icons/sort_desc.png';
import s from '../../HW15.module.css'

// добавить в проект иконки и импортировать - ok
const downIcon = '[\\/]'    // ok - changed to sortDesc
const upIcon = '[/\\]'      // ok - changed to sortAsc
const noneIcon = '[--]'     // ok - changed to sortIcon

export type SuperSortPropsType = {
    id?: string
    sort: string
    value: string
    onChange: (newSort: string) => void
}

export const pureChange = (sort: string, down: string, up: string) => {
    console.log('sort-', sort, 'down-', down, 'up-', up)
    // пишет студент, sort: (click) => down (click) => up (click) => '' (click) => down ...
    // return up

    if (sort === down) {
        return up
    } else if (sort === up) {
        return ''
    } else if (sort === '') {
        return down
    }
    return down // исправить - ok
}

const SuperSort: React.FC<SuperSortPropsType> = (
    {
        sort, value, onChange, id = 'hw15',
    }
) => {
    const up = '0' + value
    const down = '1' + value

    const onChangeCallback = () => {
        onChange(pureChange(sort, down, up))
    }

    const icon = sort === up
        ? sortDesc
        : sort === down
            ? sortAsc
            : sortIcon

    return (
        <span
            id={id + '-sort-' + value}
            onClick={onChangeCallback}
        >
            {/* сделать иконку - ok */}
            <img
                id={id + '-icon-' + sort}
                src={icon}
                alt={'sort-arrow-' + sort}
                className={s.sortArrow}
            />
        </span>
    )
}

export default SuperSort
